<template>
  <nuttrema-layout-cred>
    <template slot="content">
      <nuttrema-loader v-if="SysAdminInstanceDetails.fetching"></nuttrema-loader>
      <!-- end ~ isLoading   -->

      <nuttrema-empty-result v-else-if="SysAdminInstanceDetails.error" class="with-logo" icon="fal fa-space-shuttle">
        <template slot="text">
          <h1 v-html="$t('label.error_loading_text')"></h1>
          <h4 v-html="$t('label.error_loading_error_text')"></h4>
        </template>
      </nuttrema-empty-result>
      <!-- end ~ isError -->

      <nuttrema-empty-result v-else-if="SysAdminInstanceDetails.notFound" class="with-logo" icon="fal fa-exclamation-triangle">
        <template slot="text">
          <h1 v-html="$t('label.item_not_found')"></h1>
          <h4 v-html="$t('label.item_not_found_text')"></h4>
          <p><el-button @click="onBackEvent" type="text" icon="arrow-left">{{ $t('label.index_list') }}</el-button></p>
        </template>
      </nuttrema-empty-result>
      <!-- end ~ isNotFound -->

      <router-view v-else></router-view>
    </template>
  </nuttrema-layout-cred>
</template>

<script>
import PageProps from 'components/mixins/page-props';
import NuttremaLayoutCred from 'components/ui/layout/nuttrema-layout-cred';

export default {
  name: 'page-sys-admin-instance-details-view',
  mixins: [
    PageProps,
  ],
  props: {
    id: {
      required: false,
      default: null,
    },
  },
  components: {
    NuttremaLayoutCred,
  },
  computed: {
    SysAdminInstanceDetails() {
      return this.$store.getters.SysAdminInstanceDetails(this.id);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/system-administration/instances/shared/page-sys-admin-instance-details-view.vue